import AsyncSelect from 'react-select/async';
import RoleApi from 'api/role';

const loadOptions = (input_value, callback) => {
  RoleApi.fetch().then(data => {
    const options = data.map(item => {
      return {
        value: item.id,
        label: item.name,
        ...item,
      };
    });

    callback(options.filter(item => item.name.toLowerCase().includes(input_value.toLowerCase())));
  });
};

const RoleSelect = props => (
  <AsyncSelect
    isClearable
    isMulti
    required
    placeholder="Selecione um ou mais papéis."
    className="select col-3"
    classNamePrefix="select"
    cacheOptions
    defaultOptions
    loadOptions={loadOptions}
    {...props}
  />
);
export default RoleSelect;
